/**首页模块 */
import request from '../request/http';
function queryId(){
    return sessionStorage.getItem('institutionTenantId')||'';
}
/**获取资源数量 */
export function GetResDataCount(){
    return request({
        url: '/sp/home/getResDataCount',
        method: 'post',
        headers:{
            'institutionTenantId':queryId()
        }
    })
}
/**获取操作数量 */
export function GetOptCount(){
    return request({
        url: '/sp/home/getOptCount',
        method: 'post',
        headers:{
            'institutionTenantId':queryId()
        }
    })
}
/**获取数据排行 */
export function GetDataRanking(data){
    return request({
        url: `/sp/home/getDataRanking?orderType=${data}`,
        method: 'post',
        headers:{
            'institutionTenantId':queryId()
        }
    })
}
/**获取首页仿真软件 */
export function GetHomeSoftware(){
    return request({
        url: '/sp/home/getHomeSoftware',
        method: 'post',
        headers:{
            'institutionTenantId':queryId()
        }
    })
}
/**获取首页课程 */
export function GetHomeCourse(){
    return request({
        url: `/sp/home/getHomeCourse`,
        method: 'post',
        headers:{
            'institutionTenantId':queryId()
        }
    })
}
/**获取首页视频资源 */
export function GetResData(){
    return request({
        url: `/sp/home/getResData`,
        method: 'post',
        headers:{
            'institutionTenantId':queryId()
        }
    })
}
/**分页查询首页学校配置 */
export function GetHomeTenant(){
    return request({
        url: `/sp/home/getHomeTenant`,
        method: 'post',
    })
}
/**获取首页热门课程 */
export function GetHomeHeatCourse(){
    return request({
        url: `/sp/home/getHomeCourse`,
        method: 'post',
        headers:{
            'institutionTenantId':queryId()
        }
    })
}